import React, { useState, useEffect } from "react";
import CalculateScores from "./CalculateScores";
import { useData } from "../../../contexts/DataContext";
import useAdminWeek from "./useAdminWeek";

// Owns the working season/week (from the URL, shared with the Games tab) and
// hands CalculateScores a controlled selection. Keeping the router out of
// CalculateScores keeps that component and its tests router-free.
function ScoringPage() {
  const { getAllSeasons, currentSeason } = useData();
  const [seasons, setSeasons] = useState([]);
  const { season, week, setSeason, setWeek } = useAdminWeek();

  useEffect(() => {
    const fetchSeasons = async () => {
      const availableSeasons = await getAllSeasons();
      setSeasons(availableSeasons);
    };

    fetchSeasons();
  }, [getAllSeasons]);

  // No season in the URL, or one that doesn't exist: fall back to the active
  // season and write it back so the tabs carry a real value.
  useEffect(() => {
    if (!currentSeason) return;
    const unknown = season && seasons.length > 0 && !seasons.includes(season);
    if (!season || unknown) setSeason(currentSeason);
  }, [season, seasons, currentSeason, setSeason]);

  return (
    <CalculateScores
      seasons={seasons}
      season={season || currentSeason || ""}
      week={week}
      onSeasonChange={setSeason}
      onWeekChange={setWeek}
    />
  );
}

export default ScoringPage;
